import { render, staticRenderFns } from "./AnswerLabel.vue?vue&type=template&id=7aaa8c1a&scoped=true"
import script from "./AnswerLabel.vue?vue&type=script&lang=js"
export * from "./AnswerLabel.vue?vue&type=script&lang=js"
import style0 from "./AnswerLabel.vue?vue&type=style&index=0&id=7aaa8c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa8c1a",
  null
  
)

export default component.exports